import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private errorService: ErrorService) { }

  public defineAlertMessage(message, title, classAlert, showAlert: boolean = true, tentativa: number = 0): number{
    
    if(classAlert=="alert-success")
      tentativa = 0;
    else
      tentativa++;

    this.errorService.setShowAlert(
      new ErrorMessage
      (
        showAlert,
        classAlert,
        title,
        message,
        tentativa
      )
    );

    if(tentativa==3)
      tentativa = 0;

    return tentativa;
  }

  public alertSuccess(message: string, title: string = null){
    this.errorService.setShowAlert(
      new ErrorMessage
      (
        true,
        "alert-success",
        title,
        message,
        0
      )
    );
  }

  public alertDanger(message: string, title: string = null){
    this.errorService.setShowAlert(
      new ErrorMessage
      (
        true,
        "alert-danger",
        title,
        message,
        0
      )
    );
  }

  public alertWarning(message: string, title: string = null){
    this.errorService.setShowAlert(
      new ErrorMessage
      (
        true,
        "alert-warning",
        title,
        message,
        0
      )
    );
  }

  public limpaAlertMessage(){
    //Limpa alert
    this.errorService.setShowAlert(new ErrorMessage(), false);
  }
}

@Injectable()
export class ErrorService {
  error = new BehaviorSubject<ErrorMessage>(
    new ErrorMessage(
      false,
      null,
      null,
      null,
      0
    )
  );

  public setShowAlert(error: ErrorMessage, scrollTo: boolean = true): void {
    this.error.next(error);

    //Move o scroll para o top da página para exibir sempre o alerta
    if(scrollTo)
      window.scrollTo(0, 0);
  }

  public getShowAlert(): Observable<ErrorMessage> {
    return this.error.asObservable();
  }
}

export class ErrorMessage{
  constructor(showAlert: boolean = false,
              classAlert: string = null,
              alertTitle: string = null,
              alertMessage: string = null,
              tentativa: number = 0){

    this.showAlert = showAlert;
    this.classAlert = classAlert;
    this.alertTitle = alertTitle;
    this.alertMessage = alertMessage;
    this.tentativa = tentativa;
  }

  showAlert: boolean;
  classAlert: string;
  alertTitle: string;
  alertMessage: string;
  tentativa: number;
}